(function () {
  var PRECEDENCE = ['cookie', 'practice_notice', 'privacy', 'newsletter', 'whatsapp_qr', 'campaign', 'french_contact', 'practice_opt_in'];

  window.InuvetPopupCoordinator = {
    PRECEDENCE: PRECEDENCE,
    registrants: {},
    pagePopupConsumed: false,
    activePagePopup: null,
    pageLoadHooked: false,
    pageLoadRan: false,

    isEligible: function (registrant) {
      if (!registrant) return false;
      if (typeof registrant.eligible === 'function') return registrant.eligible();
      return registrant.eligible !== false;
    },

    register: function (id, options) {
      if (!id || !options || typeof options.show !== 'function') return;

      this.registrants[id] = {
        eligible: options.eligible !== false,
        isDismissed:
          typeof options.isDismissed === 'function' ? options.isDismissed : function () {
            return false;
          },
        show: options.show,
        delaySeconds: Number(options.delaySeconds) || 0,
      };

      this.schedulePageLoad();

      if (this.pageLoadHooked && !this.pageLoadRan && !this.pagePopupConsumed) {
        var coordinator = this;
        setTimeout(function () {
          coordinator.runPageLoad();
        }, 0);
      }
    },

    resolvePageLoadWinner: function () {
      if (this.pagePopupConsumed) return null;

      for (var i = 0; i < PRECEDENCE.length; i++) {
        var id = PRECEDENCE[i];
        var registrant = this.registrants[id];
        if (!this.isEligible(registrant)) continue;

        try {
          if (registrant.isDismissed()) continue;
        } catch (error) {
          continue;
        }

        return id;
      }

      return null;
    },

    schedulePageLoad: function () {
      var coordinator = this;
      if (coordinator.pageLoadHooked) return;
      coordinator.pageLoadHooked = true;

      var flush = function () {
        setTimeout(function () {
          coordinator.runPageLoad();
        }, 0);
      };

      if (document.readyState === 'loading' || document.readyState === 'interactive') {
        document.addEventListener('DOMContentLoaded', flush, { once: true });
      } else {
        flush();
      }
    },

    runPageLoad: function () {
      if (this.pageLoadRan || this.pagePopupConsumed) return;

      var winner = this.resolvePageLoadWinner();
      if (!winner) return;

      this.pageLoadRan = true;

      var registrant = this.registrants[winner];
      var delayMs = Math.max(0, registrant.delaySeconds) * 1000;
      var coordinator = this;

      setTimeout(function () {
        if (coordinator.pagePopupConsumed) return;

        var current = coordinator.registrants[winner];
        if (!coordinator.isEligible(current)) return;

        try {
          if (current.isDismissed()) return;
        } catch (error) {
          return;
        }

        coordinator.pagePopupConsumed = true;
        coordinator.activePagePopup = winner;
        current.show();
      }, delayMs);
    },

    canShowEventPopup: function (id) {
      if (this.pagePopupConsumed) return false;

      var registrant = this.registrants[id];
      if (!this.isEligible(registrant)) return false;

      try {
        return !registrant.isDismissed();
      } catch (error) {
        return false;
      }
    },

    markConsumed: function () {
      this.pagePopupConsumed = true;
      this.activePagePopup = null;
    },

    complete: function (id, options) {
      if (id && this.activePagePopup !== id) return;

      this.pagePopupConsumed = false;
      this.activePagePopup = null;

      if (options && options.rerun === false) return;

      this.pageLoadRan = false;

      var delayMs = Math.max(0, Number(options && options.delaySeconds) || 0) * 1000;
      var coordinator = this;

      setTimeout(function () {
        coordinator.runPageLoad();
      }, delayMs);
    },
  };
})();
